import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FlareIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flare"}/>
}
